const APIS = {
  DEFAULT_BRANCH: "/fleetservice/api/branch/default-branch/",
  STAFF: "/fleetservice/api/staff/",
  USER: "/fleetservice/api/user/",
  RIDER:"/fleetservice/api/driver/",
  USER_PROFILE: "/fleetservice/api/user-profile/",
  CLIENT_TYPE: "/fleetservice/api/client-type/",
  KM_RECORD_SETTING: "/fleetservice/api/per-km-record/",
  KM_RECORD: "/fleetservice/api/km-record/",
};

export default APIS;